import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import { Link } from 'react-router-dom';

type FacilityDisplayFields = Partial<Pick<Facility, 'id' | 'name' | 'city' | 'state'>>;

export function formatFacilityText(facility: FacilityDisplayFields | null | undefined): string {
  if (!facility) {
    return '';
  }
  const name = facility.name ?? '';
  const city = facility.city ?? '';
  const state = facility.state ?? '';
  if (!name && !city && !state) {
    return '';
  }
  if (city || state) {
    return `${name} (${city}, ${state})`;
  }
  return name;
}

export function formatFacility(facility: FacilityDisplayFields | null | undefined): React.ReactNode {
  if (!facility) {
    return null;
  }
  const text = formatFacilityText(facility);
  if (facility.id != null) {
    return <Link to={`/facilities/view/${facility.id}`}>{text}</Link>;
  }
  return text;
}

export const FacilityDisplay: React.FC<{ facility: FacilityDisplayFields | null | undefined }> = ({ facility }) => {
  return <>{formatFacility(facility)}</>;
};